import { TFormData, TJourneySection } from "../types";

const nonFormInputs = [
"info",
"summary",
"blocker",
"message",
"html",
"notification",
"summaryList",
"InfoWithHyperLink",
"quoteBox",
"documents",
"coverInfo",
"sectionHeading",
]

export function isFormValid(section: TJourneySection | undefined, validations: TFormData['validations']): boolean {
    const visibleFields = section?.fields?.filter((f) => !f.hidden) || [];

    return visibleFields.every((field) => {
      // Skip validation for ignored fields or non-form input types
      if (field.ignoreValidation || nonFormInputs.includes(field.type)) {
      return true;
      }

      // Handle group fields by checking each sub-field
      if (field.type === 'group') {
      const groupFields = field.fields?.filter((subField) => !subField.hidden) || [];
      return groupFields.every((subField) => {
        if (!subField.required || subField.ignoreValidation || nonFormInputs.includes(subField.type)) {
        return true;
        }
        return validations[subField.name] === true;
      });
      }

      if (!field.required) return true
      // For regular fields, check validation
      return validations[field.name] === true;
    });
  }
  